import React, { useState, useEffect } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import { Icon } from "@iconify/react";
// material
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  TableContainer,
  TableCell,
  TableBody,
  Paper,
  TableRow,
  Table,
  TableHead,
} from "@material-ui/core";
import { useSnackbar } from "src/components/snackbar";
import { ajustesApi } from "src/services/ajustesApi";

export default function EditarElementoBaseCliente(props) {
  const { openEditar, setOpenEditar, elemento } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [componentesAsociados, setComponentesAsociados] = useState([]);

  const [openAgregarElemento, setOpenAgregarElemento] = useState(false);
  const [elementoSelector, setElementoSelector] = useState("");
  const elementoSeleccionado = elemento[0];
  const [cargarOpcionesSelector] = ajustesApi.useLazyGetSelectorElementoQuery();
  const [deleteRelacionesSelectorElemento] =
    ajustesApi.useDeleteRelacionSelectorElementoMutation();
  const [addRelacionSelectorElemento] =
    ajustesApi.useAddRelacionSelectorElementoMutation();

  useEffect(() => {
    const cargarComponentes = async () => {
      const { data, error } = await cargarOpcionesSelector(
        elementoSeleccionado.id,
      );
      if (error) {
        enqueueSnackbar("Error al cargar las opciones del selector.", {
          variant: "error",
        });
        return;
      }
      setComponentesAsociados(data);
    };
    cargarComponentes();
  }, [elementoSeleccionado.id, cargarOpcionesSelector, enqueueSnackbar]);

  const handleClickOpenAgregar = () => {
    setOpenAgregarElemento(true);
  };

  const handleChangeNombreElementoSelector = (event) => {
    setElementoSelector(event.target.value);
  };

  const handleCloseAgregar = () => {
    setOpenAgregarElemento(false);
    setElementoSelector("");
  };

  const agregarElemento = () => {
    let elementosAux = componentesAsociados;
    let elemento = elementosAux.filter(
      (element) =>
        element.nombreElemento.toUpperCase() === elementoSelector.toUpperCase(),
    )[0];

    if (elemento) {
      enqueueSnackbar("El elemento ya existe.", {
        variant: "error",
      });
    } else {
      elementosAux.push({
        nombreElemento: elementoSelector.toUpperCase(),
      });
      setComponentesAsociados(elementosAux);
    }

    setElementoSelector("");
    setOpenAgregarElemento(false);
  };

  const guardarPlan = async () => {
    if (elementoSeleccionado.componente === "select") {
      try {
        await deleteRelacionesSelectorElemento(
          elementoSeleccionado.id,
        ).unwrap();

        const promesas = componentesAsociados.map((element) =>
          addRelacionSelectorElemento({
            refComponente: elementoSeleccionado.id,
            nombreElemento: element.nombreElemento,
          }).unwrap(),
        );
        await Promise.all(promesas);
        setOpenEditar(false);
        enqueueSnackbar("Opciones del selector actualizadas correctamente.", {
          variant: "success",
        });
      } catch {
        enqueueSnackbar("Error al actualizar las opciones del selector.", {
          variant: "error",
        });
      }
    }
  };

  const cancelar = () => {
    setOpenEditar(false);
  };
  return (
    <>
      <Dialog open={openEditar} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Editar Selector</DialogTitle>
        <DialogContent>
          {elementoSeleccionado.componente === "select" ? (
            <div>
              <TextField
                autoFocus
                margin="dense"
                label="Nombre Columna"
                type="text"
                value={elementoSeleccionado.nombreColumna}
                fullWidth
                disabled
              />
              <Button
                color="primary"
                startIcon={<Icon icon={plusFill} />}
                style={{ marginTop: "10px" }}
                onClick={handleClickOpenAgregar}
              >
                Agregar Elemento Selector
              </Button>

              <TableContainer component={Paper} style={{ marginTop: "10px" }}>
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre Elemento Selector</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {componentesAsociados.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {row.nombreElemento}
                        </TableCell>
                        <TableCell align="right">
                          <Button
                            onClick={() => {
                              let componentes = componentesAsociados.filter(
                                (dato) =>
                                  dato.nombreElemento !== row.nombreElemento,
                              );
                              setComponentesAsociados(componentes);
                            }}
                            color="error"
                          >
                            Eliminar
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : (
            <div></div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelar} color="error">
            Cancelar
          </Button>
          <Button onClick={guardarPlan} color="primary">
            Guardar Cambios
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openAgregarElemento} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
          Nombre Elemento Selector
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre Elemento Selector"
            type="text"
            value={elementoSelector}
            onChange={handleChangeNombreElementoSelector}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAgregar} color="error">
            Cancelar
          </Button>
          <Button onClick={agregarElemento} color="primary">
            Agregar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
